<script>
export default {
  name: 'popup-z-index',
  data () {
    return {
      popupID: ''
    }
  },
  computed: {
    getPopupZindex () {
      return this.$store.state.global.popupsZindexes[this.popupID];
    }
  },
  methods: {
    increasePopupZindex () {
      this.popupID = 'popup-' + new Date().getTime();
      this.$store.commit('global/setIncreasedPopupZindex', this.popupID);
    },
    removePopupZindex () {
      this.$store.commit('global/removePopupZindex', this.popupID);
    },
    popupClicked () {
      this.$bus.$emit('popup-clicked');
      return false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/PopupZindex.vue